import React, { Component } from 'react'
import { Table, Tooltip, Modal, Form, Button, Input, message, Select, Radio } from 'antd'
import NumberFormat from 'react-number-format'
import Currency from 'react-currency-formatter';
import { connect } from 'dva'
import { Link } from 'dva/router'
import { all, create } from '../../services/restApi'
import InfiniteScroll from '@fand/react-infinite-scroll-container';
import config from '../../utils/config'
var Icon = require('react-fontawesome');
const _ = require('underscore')

const { Column } = Table;
const confirm = Modal.confirm
const FormItem = Form.Item;
const TextArea = Input.TextArea;
const Option = Select.Option;
const ButtonGroup = Button.Group;
const RadioGroup = Radio.Group;

class adonType extends Component {

	constructor (props) {
		super(props);

		this.state = {
			hotels: [],
            parents_adons: [],
            query: {}
		};

		if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
			this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};
	}


	/**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        // Query
        let query = {};
        if (this.state.currentHotel)
            query.objectId = this.state.currentHotel.objectId
        
        if (this.props.app.user.type === 'gerente') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        // Consulta los hoteles
        all('Hotel', {where: query, limit: 20}).then((resp) => {
            if (this.state.currentHotel) 
                this.props.form.setFieldsValue({hotel: {key: this.state.currentHotel.objectId, label: this.state.currentHotel.name}});

            this.setState({ hotels: resp.results });
        })

        // Consulta las categorías principales del hotel asignado al gerente o recepcionista
        if (this.state.currentHotel) {
            all('AdonType', {
                where: {
                    type: 'principal', 
                    hotel: {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId}
                }, 
                limit: 20
            }).then((resp) => {
                this.setState({ parents_adons: resp.results });
            })
        }

        this.firstLoad();
    }


    /**
    * Primera carga
    */
    firstLoad (hasFilter) {
        this.props.dispatch({ type: 'app/showLoadingTable' })

        let query = {type: 'principal'};

        // hasFilter viene al crear o actualizar un registro, trae el hotel que se encuentra en el select para mantener el filtro
        if (hasFilter)
            query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: hasFilter}

        if (this.props.app.user.type === 'gerente') {
            query.hotel = {$in: this.props.app.user.hotels}
        }

        if (this.state.currentHotel)
            query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId}

        all('AdonType', {
            where: query,
            include: 'hotel,parent_category', 
            skip: 0, 
            limit: this.props.adonType.limit,
            count: 1, 
            order: '-createdAt'
        }).then(resp => {

            if (resp.results.length > 0) {
                const adonTypes = [];
                resp.results.map((item, key) => {

                    return all('AdonType', {
                        where: {
                            parent_category: {__type: 'Pointer', className: 'AdonType', objectId: item.objectId}
                        },
                        include: 'hotel,parent_category'
                    }).then(adons => {
                        if (adons.results.length > 0)
                            item.children = adons.results;

                        adonTypes.push(item);

                        if (key === resp.results.length - 1) {
                            setTimeout(function() {
                                this.props.dispatch({ type: 'app/hideLoadingTable' })
                                this.props.dispatch({type: 'adonType/queryFirst', payload: {
                                    adonTypes: adonTypes, 
                                    skip: 0, 
                                    limit: this.props.adonType.limit,
                                    total_items: resp.count,
                                }})
                            }.bind(this), 100);
                        }
                    });
                });

            } else {
                this.props.dispatch({ type: 'app/hideLoadingTable' })
            }
        });
    }


    /**
    * Carga más registros
    */
    loadMore () {
    	if (this.props.adonType.skip < this.props.adonType.total_items) {
            this.props.dispatch({ type: 'app/showLoadingTable' })

    		let query = {...this.state.query};
    		if (this.state.currentHotel)
    			query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId}

            if (this.props.app.user.type === 'gerente') {
                query.hotel = {$in: this.props.app.user.hotels}
            }

            all('AdonType', {
                where: query,
                include: 'hotel,parent_category', 
                skip: this.props.adonType.skip, 
                limit: this.props.adonType.limit,
                count: 1, 
                order: '-createdAt'
            }).then(resp => {

                const adonTypes = [];
                resp.results.map((item, key) => {

                    return all('AdonType', {
                        where: {
                            parent_category: {__type: 'Pointer', className: 'AdonType', objectId: item.objectId}
                        },
                        include: 'hotel,parent_category'
                    }).then(adons => {
                        if (adons.results.length > 0)
                            item.children = adons.results;

                        adonTypes.push(item);

                        if (key === resp.results.length - 1) {

                            setTimeout(function() {
                                this.props.dispatch({ type: 'app/hideLoadingTable' })
                                this.props.dispatch({type: 'adonType/querySuccess', payload: {
                                    adonTypes: adonTypes, 
                                    skip: this.props.adonType.skip, 
                                    limit: this.props.adonType.limit,
                                    total_items: resp.count,
                                }})
                            }.bind(this), 100);
                        }
                    });
                });
            });
    	}
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetch (value, callback) {
        let query = {};
        query.name = {$regex: '(?i)' + value};
        
        if (this.props.app.user.type === 'gerente') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        setTimeout(() => {
            all('Hotel', {where: {name: {$regex: '(?i)' + value}}}).then((d) => {
                const results = d.results;
                const hotels = [];
                
                results.forEach((r) => {
                    hotels.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(hotels);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        if (value && value.key && !value.label) {
            this.fetch(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }
    }


    /**
    * Encuentra las coincidencias según la cadena del input Categoría principal (Adon principal)
    */
    fetchAdon (value, callback) {

        if (this.props.form.getFieldValue('hotel')) {
            let query = {name: {$regex: '(?i)' + value}};
            query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.props.form.getFieldValue('hotel').key}

            setTimeout(() => {
                all('AdonType', {where: query}).then((d) => {
                    const results = d.results;
                    const parents_adons = [];
                    
                    results.forEach((r) => {
                        parents_adons.push({
                            objectId: r.objectId,
                            name: r.name,
                        });
                    });

                    callback(parents_adons);
                });
            }, 500);
        }
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectAdonChange (value) {
        if (value && value.key && !value.label) {
            this.fetchAdon(value.key, (resp) => {
                this.setState({ parents_adons: resp })
            });
        }
    }


    /**
    * Validator: Checa que se haya elegido un hotel de la lista
    */
    checkHotel (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija el hotel!');
        } else {
            // Consulta las categorías principales del hotel en el select
            all('AdonType', {
                where: {
                    type: 'principal', 
                    hotel: {__type: 'Pointer', className: 'Hotel', objectId: value.key}
                }, 
                limit: 20
            }).then((resp) => {
                this.setState({ parents_adons: resp.results });
            })

            this.search(value)
            callback();
        }
    }

    /**
    * Validator: Checa que se haya elegido un adon principal de la lista
    */
    checkType (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija la categoría principal!');
        } else {
            callback();
        }
    }


    /**
    * Validator: Checa que el monto sea mayor a 0
    */
    checkPrice (rule, value, callback) {
        if (value && !_.isNumber(value) && Number(value.replace(/[^\d.]/g, '')) === 0) {
            callback('Por favor, ingrese un monto correcto!');
        } else {
            callback();
        }
    } 


    /**
    * Búsqueda
    */
    search (value) {
        let query = this.state.query;
        query.type = 'principal';

        // Query
        if (value && value.key) {
            query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: value.key};
        }

        this.setState({query: query});
        this.props.dispatch({ type: 'app/showLoadingTable' })
        this.props.dispatch({type:'adonType/filterSuccess', 
            payload: {
                adonTypes: [], 
                limit: 0, 
            }
        });

        all('AdonType', {
            where: query,
            include: 'hotel', 
            skip: 0, 
            limit: this.props.adonType.limit,
            count: 1, 
            order: '-createdAt'
        }).then(resp => {

            if (resp.results.length > 0) {
                const adonTypes = [];
                resp.results.map((item, key) => {

                    return all('AdonType', {
                        where: {
                            parent_category: {__type: 'Pointer', className: 'AdonType', objectId: item.objectId}
                        },
                        include: 'hotel,parent_category'
                    }).then(adons => {
                        if (adons.results.length > 0)
                            item.children = adons.results;

                        adonTypes.push(item);

                        if (key === resp.results.length - 1) {

                            setTimeout(function() {
                                this.props.dispatch({ type: 'app/hideLoadingTable' })
                                this.props.dispatch({type: 'adonType/filterSuccess', payload: {
                                    adonTypes: adonTypes, 
                                    skip: 0, 
                                    limit: this.props.adonType.limit,
                                    total_items: resp.count,
                                }})
                            }.bind(this), 100);
                        }
                    });
                });
            } else {
                this.props.dispatch({ type: 'app/hideLoadingTable' })
            }
        });
    }


    /**
    * Elimina un registro
    */
    delete_item (item) {
    	this.setState({currentAdon: ''});
    	let dispatch = this.props.dispatch

        if (this.state.currentHotel)
            this.props.form.resetFields(['name', 'description']);
        else
            this.props.form.resetFields();

    	confirm({
	    	title: '¿Estás seguro que deseas eliminar el servicio?',
	      	onOk () {
	        	dispatch({type: 'adonType/removeItem', payload: item});
	      	}
	    })
    }


    /**
    * Establece el registro para editar
    */
    setUpdate (item) {
    	this.setState({currentAdon: item.objectId});

        let obj = {...item};
    	if (obj.hotel) obj.hotel = {key: obj.hotel.objectId, label: obj.hotel.name};
        if (obj.parent_category) obj.parent_category = {key: obj.parent_category.objectId, label: obj.parent_category.name};

        this.props.form.setFieldsValue({type: obj.type});

        setTimeout(function() {
            this.props.form.setFieldsValue(obj);
            window.scrollTo(0, 0)
        }.bind(this), 100);
    }


    /**
    * Cancela la edición
    */
    cancel_update () {
        this.setState({currentAdon: ''});
                                                    
        if (this.state.currentHotel)
            this.props.form.resetFields(['name', 'description']);
        else
            this.props.form.resetFields();
    }


    /**
    * Envío del formulario
    */
    handleSubmit (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Model
            let data = {...values};
            data.hotel = {__type: 'Pointer', className: 'Hotel', objectId: values.hotel.key};

            if (values.price)
                _.isNumber(values.price) ? data.price = values.price : data.price = Number(values.price.replace(/[^\d.]/g, ''))
            else
                data.price = 0;

            if (values.parent_category) {
                data.parent_category = {__type: 'Pointer', className: 'AdonType', objectId: values.parent_category.key};
            }
            
            if (!this.state.currentAdon) {
                // CREA
                
                this.props.dispatch({type: 'app/showButtonLoading'})

                create('AdonType', data).then(resp => {

                    resp.hotel = {objectId: values.hotel.key, name: values.hotel.label};
                	_.extend(data, resp);

                    this.props.dispatch({type: 'app/hideButtonLoading'})
                    message.success('Se ha creado el servicio exitosamente');

                    this.props.dispatch({type: 'adonType/createSuccess', payload: data})
                    this.firstLoad(resp.hotel.objectId);

                    this.props.form.resetFields(['name', 'description']);

                    // Si es categoría principal, entonces la agregamos al instante al array de adons_options
                    if (data.type === 'principal') {
                        this.setState({ parents_adons: [...this.state.parents_adons, data] });
                    }

                }).catch(e => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})

                    if (e && e.data) message.error(e.data.error);
                    else message.error('Ha ocurrido un error. Intente más tarde')    
                });

            } else {
                // ACTUALIZA

                data.objectId = this.state.currentAdon;
                data.hotel = {objectId: values.hotel.key, name: values.hotel.label};

                if (data.parent_category)
                    data.parent_category = {objectId: values.parent_category.key, name: values.parent_category.label};

                this.props.dispatch({type: 'adonType/update', payload: data})
                this.firstLoad(data.hotel.objectId);

                this.setState({currentAdon: ''});
                this.props.form.resetFields(['name', 'description']);
            }
        })
    }

    render () {
    	const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)
        const adons_options = this.state.parents_adons.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

	    return (
	        <div className="content-wrapper">
	            <section className="content-header">
	            	<h1>Servicios adicionales</h1>
	            </section>

	            <section className="content">
	            	<div className="row">
		            	<div className="col-md-4">
			                <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>

			                	<div className="box-body">
	                            	<Form onSubmit={this.handleSubmit.bind(this)}>
		                                <div className="row">
                                            <div className="col-md-12">
                                                <FormItem label="Elija el Hotel" hasFeedback>
                                                    {this.props.form.getFieldDecorator('hotel', {
                                                        rules: [{
                                                            required: true,
                                                            message: 'Por favor, elija el hotel',
                                                        }, {
                                                            validator: this.checkHotel.bind(this)
                                                        }]
                                                    })(
                                                        <Select 
                                                            size='large'
                                                            mode="combobox"
                                                            onChange={this.handleSelectHotelChange.bind(this)}
                                                            filterOption={false}
                                                            labelInValue={true}
                                                            optionLabelProp='label'
                                                            >
                                                            {hotel_options}
                                                        </Select>
                                                    )}
                                                </FormItem>
                                            </div>

                                            <div className="col-md-12">
                                                <FormItem label="Tipo" hasFeedback>
                                                    {this.props.form.getFieldDecorator('type', {
                                                        initialValue: 'principal',
                                                        rules: [{
                                                            required: true,
                                                            message: 'Por favor, elija el tipo'
                                                        }]
                                                    })(
                                                        <RadioGroup onChange={this.onChangeType}>
                                                            <Radio value="principal">Principal</Radio>
                                                            <Radio value="secundario">Secundario</Radio>
                                                        </RadioGroup>
                                                    )}
                                                </FormItem>
                                            </div>

                                            {this.props.form.getFieldValue('type') && this.props.form.getFieldValue('type') === 'secundario'
                                                ? <div className="col-md-12">
                                                    <FormItem label="Categoría principal" hasFeedback>
                                                        {this.props.form.getFieldDecorator('parent_category', {
                                                            rules: [{
                                                                required: true,
                                                                message: 'Por favor, elija la categoría principal',
                                                            }, {
                                                                validator: this.checkType.bind(this)
                                                            }]
                                                        })(
                                                            <Select 
                                                                size='large'
                                                                mode="combobox"
                                                                onChange={this.handleSelectAdonChange.bind(this)}
                                                                filterOption={false}
                                                                labelInValue={true}
                                                                optionLabelProp='label'
                                                                >
                                                                {adons_options}
                                                            </Select>
                                                        )}
                                                    </FormItem>
                                                </div>
                                                : ''
                                            }

		                                    <div className="col-md-12">
		                                        <FormItem label="Nombre" hasFeedback>
		                                            {this.props.form.getFieldDecorator('name', {
		                                                rules: [{
		                                                    required: true,
		                                                    message: 'Por favor, ingrese el nombre del servicio'
		                                                }]
		                                            })(<Input size='large' placeholder="Nombre del servicio" />)}
		                                        </FormItem>
		                                    </div>

                                            <div className="col-md-12">
                                                <FormItem label="Precio" hasFeedback>
                                                    {this.props.form.getFieldDecorator('price', {
                                                        rules: [{
                                                            required: this.props.form.getFieldValue('type') === 'principal' ? false : true,
                                                        }, {
                                                            validator: this.checkPrice.bind(this)
                                                        }]
                                                    })(
                                                        <NumberFormat 
                                                            thousandSeparator={true} 
                                                            prefix={'$'} 
                                                            className="ant-input ant-input-lg" />
                                                    )}
                                                </FormItem>
                                            </div>

		                                    <div className="col-md-12">
		                                    	<FormItem label="Breve descripción" hasFeedback>
	                                        		{this.props.form.getFieldDecorator('description')(<TextArea rows={4} />)}
	                                    		</FormItem>
	                                    	</div>
		                                </div>

			                            <div className="row text-center paddingBottom30">
			                                <Button type='primary' onClick={this.handleSubmit.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'} style={{marginRight: '10px'}}>
			                                    {!this.state.currentAdon ? 'Guardar' : 'Actualizar'}
			                                </Button>

			                                {this.state.currentAdon
			                                	? <Button type='danger' onClick={this.cancel_update.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
				                                    Cancelar
				                                </Button>
				                                : ''
			                                }
			                            </div>
				                    </Form>
			                    </div>

			                </div>
			            </div>

			            <div className="col-md-8">
			                <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>

			                	<div className="box-body">
	                            	<div className="table-responsive table">

		                            	<InfiniteScroll
										    padding={50}
									        throttle={100}
									        onScroll={() => this.loadMore()}>

		                                    <Table 
		                                    	dataSource={this.props.adonType.adonTypes} 
		                                    	rowKey="objectId" size="middle" 
		                                    	loading={this.props.app.loadingTable} 
		                                    	pagination={false}>
		                                    	
		                                        <Column title="Nombre" dataIndex="name" key="name" />
                                                <Column title="Precio" key="price" render={(item) => (
                                                    <span>
                                                        {item.price
                                                            ? <Currency quantity={item.price} currency="USD" />
                                                            : '-'
                                                        }
                                                    </span>
                                                )}/>
		                                        <Column title="Descripción" dataIndex="description" key="description" />
		                                        {!this.state.currentHotel
			                                        ? <Column title="Hotel" key="hotel" render={(item) => (
			                                        	<span>{item.hotel ? item.hotel.name : '-'}</span>
			                                        )} />
			                                        : ''
		                                    	}
		                                        <Column title="Acciones" key="action"
		                                            render={(item) => (
		                                                <span className="actions">
                                                            <ButtonGroup>
                                                                <Tooltip placement="bottom" title="Editar">
                                                                    <Button>
                                                                        <Link onClick={() => { this.setUpdate(item) }}><Icon name="edit" /></Link>
                                                                    </Button>
                                                                </Tooltip>

                                                                {(item.children && item.children.length === 0) || !item.children
                                                                    ?<Tooltip placement="bottom" title="Eliminar">
                                                                        <Button>
                                                                            <Link onClick={() => { this.delete_item(item) }} className=""><Icon name="trash" /></Link>
                                                                        </Button>
                                                                    </Tooltip>
                                                                    : ''
                                                                }
                                                            </ButtonGroup>
		                                                </span>
		                                            )}
		                                        />
		                                    </Table>        
			                            </InfiniteScroll>
		                            </div>
			                    </div>

			                </div>
			            </div>
			        </div>
	            </section>
	        </div>
	    )
	}
}

export default connect(({adonType, app}) => ({adonType, app}))(Form.create()(adonType))


// WEBPACK FOOTER //
// ./src/components/catalogs/adons.js